// contract-channel
import { axios } from '../index'
// 引入oss相关模块
import co from 'co'
import OSS from 'ali-oss'
import { k1 } from '@/xhr/services/osssp'
let scope = 'oss'
// 注册token地址
const registerToken = (fileCount) => {
   return axios.post('/oss/token', {
      fileCount,
      ossType: 'image'
    })
}
// 上传图片 根据返回的token数据进行上传 支持type为IMG FILE两种列表类型
export const uploadFiles = (fileList) => {
  return new Promise((resolve, reject) => {
    registerToken(fileList.length).then(res => {
      if (res.data.code === 200) {
        let { key, secret, fileNames } = res.data.data
        const client = new OSS({
          region: k1.a_4 + '-cn-' + k1.a_0,
          accessKeyId: key,
          accessKeySecret: secret,
          bucket: k1.a_7 + '-' + k1.a_5 + k1.a_9 + '-' + k1.a_6
        })
        // 分别上传对应的文件
        co(function* () {
          let ret = []
          for (let i = 0; i < fileNames.length; i++) {
            const o = yield client.put(fileNames[i], fileList[i].raw)
            ret.push(o)
          }
          resolve(ret)
        }).catch(err => {
          console.error(`OSS上传失败。原因：${err.code}`)
          reject(`OSS上传失败。原因：${err.code}`)
        })
      } else {
        reject(res.data.message)
        console.error(res.data.message)
      }
    })
  }
  )
}
// 阿里oss的文件上传 包括得到token，上传文件两个接口
export default {
  // 阿里oss地址 配置upload中action属性需要
  baseUrl: 'http://' + k1.a_7 + '-' + k1.a_5 + k1.a_9 + '-' + k1.a_6 + '.' + k1.a_4 + '-' + k1.a_3 + '-' + k1.a_0 + '.' + k1.a_2 + k1.a_8 + k1.a_1 + '.com/',
  // 获取阿里token
  getToken(fileCount) {
    return axios.post(`/oss/token`, {
      fileCount,
      ossType: 'image'
    })
  },

  // 上传文件接口  上传图片与上传普通文件均使用此方法
  uploadFiles(fileList) {
    return uploadFiles(fileList)
  },
   /** 百度ai身份证识别接口
    * @param
    * url: String 阿里云图片地址
    * id_card_side: String 'front' 'back' 身份证正反面
    */
   getIdCardInfo(param) {
    param = {
      ...param,
      detect_direction: true,
      detect_risk: false,
      image: '',
    }
    return axios.post(`/${scope}/auth/authenticate`, param)
  }

}



// WEBPACK FOOTER //
// ./src/xhr/services/oss.js